import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IphonePreviewComponent } from '../../../../../../components/messages/iphone-preview/iphone-preview.component';
import { formatCount, smsParts, SmsParts } from '../../../../../../../utils/sms';
import { ScheduleSummary } from '../../compose-schedule';

/**
 * The right-hand column of compose: the message as an iPhone shows it, who
 * gets it once duplicates are removed, and roughly how many SMS that costs.
 */
@Component({
  selector: 'compose-aside',
  standalone: true,
  imports: [IphonePreviewComponent],
  templateUrl: './compose-aside.component.html',
  styleUrl: './compose-aside.component.css',
})
export class ComposeAsideComponent {
  @Input() senderId = '';
  @Input() body = '';
  @Input() parts: SmsParts = smsParts('');
  @Input() scheduled = false;
  @Input() schedule: ScheduleSummary | null = null;
  @Input() hasRecipients = false;
  @Input() audienceCount: number | null = null;
  @Input() countLoading = false;
  @Input() countError = '';
  @Input() countApprox = false;
  /** "3 numbers, 2 tags and 1 file". */
  @Input() breakdown = '';
  @Input() estimatedSms: number | null = null;
  @Output() retryCount = new EventEmitter<void>();

  formatCount = formatCount;

  /** The time above the message on the phone: when it is scheduled for, or now. */
  get stampAt(): Date | null {
    return this.scheduled ? (this.schedule?.at ?? null) : null;
  }

  get whenLabel(): string {
    if (!this.scheduled) return 'Sends when you confirm';
    if (this.schedule?.at) return this.schedule.when;
    return 'Scheduled, time not set';
  }

  get partsLabel(): string {
    const parts = this.parts.parts;
    return parts === 1 ? '1 part' : `${parts} parts`;
  }
}
